__turbopack_context__.v({
  "discardButton": "formStyles-module-scss-module__zHGQlG__discardButton",
  "formWrapper": "formStyles-module-scss-module__zHGQlG__formWrapper",
  "virtualListContainer": "formStyles-module-scss-module__zHGQlG__virtualListContainer",
});
